import React from "react"
import { Box } from "@mui/material"

import { AppDialogCancel, AppFormDrawer, AppFormGrid, AppFormSection } from "@components"
import { isEditUserSettingsTierDrawer, isOpenUserSettingsTierDrawer, userSettingsTierFormData } from "../../@signals"
import UserSettingTierDrawerName from "./Name"
import UserSettingTierDrawerProviders from "./Providers"
import UserSettingTierDrawerSubmit from "./Submit"


export default function UserSettingTierDrawer() {
	const onClose = () => userSettingsTierFormData.value = { }

	return <AppFormDrawer
		icon="layer-group"
		title={isEditUserSettingsTierDrawer.value ? 'Edit tier' : 'New Tier'}
		subtitle="A name and the providers it groups"
		isOpen={isOpenUserSettingsTierDrawer.value}
		controller={onClose}
		footer={<>
			<AppDialogCancel onClick={onClose}/>
			<UserSettingTierDrawerSubmit/>
		</>}
	>
		<AppFormSection icon="layer-group" title="Tier">
			<AppFormGrid>
				<Box sx={{ gridColumn: 'span 12' }}><UserSettingTierDrawerName/></Box>
				<Box sx={{ gridColumn: 'span 12' }}><UserSettingTierDrawerProviders/></Box>
			</AppFormGrid>
		</AppFormSection>
	</AppFormDrawer>
}
